import React from 'react';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

export default class WarningMessage extends React.PureComponent {
    render() {
        return <div className="compendium__warning compendium__warning--shown">
            <div className="compendium__warning-content">
                <div className="compendium__warning-icon">
                    <SpriteIcon name="#svg-warning" size={{height: 65, width: 70}} />
                </div>
                {this.props.children}
            </div>
        </div>;
    }
}
